import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Avatar, Typography } from '@mui/material';

import {  deepPurple } from '@mui/material/colors';

import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: 'white',
    borderRadius: theme.spacing(1.5),
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    margin: theme.spacing(0, 0.5),
    marginTop: theme.spacing(1),
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(2),
      marginTop: theme.spacing(0.5),
    }
  },
  avatar: {
    width: 72,
    height: 72,
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
    fontSize: '1.5rem',
    fontWeight: 600,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    border: '3px solid white',
  },
  name: {
    marginTop: theme.spacing(1.5),
    fontWeight: 600,
    color: theme.palette.text.primary,
    textAlign: 'center'
  },
  details: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    textAlign: 'center'
  },
  role: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.primary.main,
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    textAlign: 'center'
  }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const account = useSelector((state) => state.account.user);

  const user = {
    name: `${account ? account.firstName : ''} ${account ? account.lastName : ''}`,
    avatar: '/images/avatars/avatar_5.png',
    bio: account ? account.role : '',
    restaurantId: (account  && account.restaurantId) ? account.restaurantId : ''
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Profile"
        className={classes.avatar}
        component={RouterLink}
        src="/broken-image.jpg"
        to="/settings"
      >
        {account && account.lastName && account.lastName.length > 0 && account.lastName[0].toUpperCase()}
      </Avatar>
      <Typography
        className={classes.name}
        variant="h5"
      >
        {user.name}
      </Typography>
      <Typography className={classes.details}>{user.restaurantId}</Typography>
      <Typography className={classes.role}>{user.bio}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
